import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({
    onlyShowNormalCrop,
    onlyShowShortCrop,
    onlyShowSmallCrop,
    defaultThumbnail,
    specyficThumbnail,
    ...args
  }) {
    super(args)
    this.children = [
      {
        ...this.getComponentWithVModel('image-input'),
        props: {
          onlyShowNormalCrop,
          onlyShowShortCrop,
          onlyShowSmallCrop,
          defaultThumbnail,
          specyficThumbnail
        }
      }
    ]
  }
}
